import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { GenerateSalaryApi } from "./GenrateSalaryAction";
import { GetDepartmentApi } from "../department/departmentAction";
import { setHeading } from "../../../accounts/account.actions";
import _ from "lodash";
import Select from "react-select";
import moment from "moment";
import Swal from "sweetalert";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Spinner from 'react-bootstrap/Spinner';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const GenerateSalary = (props) => {
    const [departmentName, setDepartmentName] = useState("");
    const [departmentId, setDepartmentId] = useState("");
    const [financialMonth, setFinancialMonth] = useState("");
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [typeName, setTypeName] = useState("");
    const [typeId, setTypeId] = useState(0);
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

    const handleVisible = (msg) => {
        setAlertVisible(true);
        setTimeout(() => {
            setAlertVisible(false);
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    };
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true);
        setTimeout(() => {
            setDangerVisibleAlert(false);
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    };
    const PostSalary = () => {
        if (typeName === "Permanent") {
            Swal({
                title: "Are you sure?",
                text: "You want to generate salary for permanent employees. This action cannot be undone.",
                icon: "warning",
                buttons: ["Cancel", "Yes, Generate"],
                dangerMode: true,
            }).then((willGenerate) => {
                if (willGenerate) {
                    props.GenerateSalaryApi({
                        attendanceMonthYear: financialMonth,
                        typeId: typeId,
                        typeName: typeName,
                        departmentName: departmentName,
                        departmentId: departmentId,
                    },
                        handleVisible,
                        handleDangerVisible
                    );
                }
            });
        } else {
            props.GenerateSalaryApi({
                attendanceMonthYear: financialMonth,
                typeId: typeId,
                typeName: typeName,
                departmentName: departmentName,
                departmentId: departmentId,
            },
                handleVisible,
                handleDangerVisible
            );
        }
    };

    const typeList = [
        { value: 1, label: "Permanent" },
        { value: 2, label: "Temporary" },
    ];
    const handleChangeType = (selectedOption) => {
        setTypeName(selectedOption.label);
        setTypeId(selectedOption.value);
    };

    const getDepartmentNameList = !_.isEmpty(props.departmentList) && props.departmentList.map((x) => {
        let data = { value: x._id, label: x.department };
        return data
    });
    !_.isEmpty(props.departmentList) && getDepartmentNameList.unshift({ value: "ALL", label: "ALL" });
    const handleChangeDepartment = (selectedOption) => {
        setDepartmentName(selectedOption.label);
        setDepartmentId(selectedOption.value);
    };

    const handleMonthChange = (date) => {
        const monthName = moment(date).format('YYYY-MM');
        setSelectedMonth(date);
        setFinancialMonth(monthName)
    };

    useEffect(() => {
        props.GetDepartmentApi();
        props.setHeading("Generate Salary")
    }, []);

    return (
        <>
            {(props.isFetchingDepartmentData) ? (
                <div className="loader-div">
                    <Spinner
                        variant="primary"
                        animation="border"
                        size="xl"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Select Salary Type *</b></Form.Label>
                                <Select
                                    placeholder="Select Salary Type"
                                    onChange={handleChangeType}
                                    options={typeList}
                                />
                            </Form.Group>
                        </Col>
                        {typeId === 2 ? (
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label> <b>Select Department *</b></Form.Label>
                                    <Select
                                        isDisabled={_.isEmpty(getDepartmentNameList)}
                                        placeholder="Select Department"
                                        onChange={handleChangeDepartment}
                                        options={getDepartmentNameList}
                                    />
                                </Form.Group>
                            </Col>
                        ) : (
                            ""
                        )}
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label style={{ width: '100%' }}><b>Select Month *</b></Form.Label>
                                <DatePicker
                                    selected={selectedMonth}
                                    onChange={handleMonthChange}
                                    showMonthYearPicker
                                    dateFormat="MMMM yyyy"
                                    className="form-control"
                                    placeholderText="Select Month"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {typeId === 2 ? (
                        <div className="sendDiv">
                            {_.isEmpty(typeName) || _.isEmpty(departmentId) || _.isEmpty(financialMonth) ? (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> GENERATE SALARY </Button>
                            ) : (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => { PostSalary(); }}> GENERATE SALARY </Button>
                            )}
                        </div>
                    ) : (
                        <div className="sendDiv">
                            {_.isEmpty(typeName) || _.isEmpty(financialMonth) ? (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> GENERATE SALARY </Button>
                            ) : (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => { PostSalary(); }}> GENERATE SALARY </Button>
                            )}
                        </div>
                    )}

                </Container>
            )}
        </>
    )
};

const mapDispatchToProps = (dispatch) => {
    return {
        GenerateSalaryApi: (payload, handleVisible, handleDangerVisible) => dispatch(GenerateSalaryApi(payload, handleVisible, handleDangerVisible)),
        GetDepartmentApi: () => dispatch(GetDepartmentApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingDepartmentData: state.DepartmentReducer.isFetchingDepartmentData,
    departmentList: state.DepartmentReducer.departmentList,
});

export default connect(mapStateToProps, mapDispatchToProps)(GenerateSalary);
